@if (loading()) {
    <app-loader />
}